import { Pipe, PipeTransform } from '@angular/core';
import { PageGroup } from 'globals/store/permissions.data';

@Pipe({
    name: 'getGroupLink',
    standalone: true,
})
export class GetGroupLink implements PipeTransform {
  transform (group: PageGroup, mobile: boolean): string {
    return !mobile || !group.mobileHandles?.length ? group.pages[0].url : group.pages.find(p => group.mobileHandles[0] === p.handle).url
  }    
}
